import{defineMessages}from'react-intl';

export default defineMessages({
itemLabel:{
id:'i18n.sku.itemLabel',
defaultMessage:'Select Item'},

quantity:{
id:'i18n.sku.quantity',
defaultMessage:'Requested Quantity'},

retail:{
id:'i18n.sku.skuRetail',
defaultMessage:'Sku Retail'},

total:{
id:'i18n.sku.total',
defaultMessage:'Total'},

subTotal:{
id:'i18n.sku.subTotal',
defaultMessage:'Total'},

selectItem:{
id:'i18n.sku.selectItem',
defaultMessage:'Select Item'}});
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInNyYy9jb21wb25lbnRzL1N0b2NrTGlmdC9Ta3UvU2t1Lm1lc3NhZ2VzLmpzIl0sIm5hbWVzIjpbImRlZmluZU1lc3NhZ2VzIiwiaXRlbUxhYmVsIiwiaWQiLCJkZWZhdWx0TWVzc2FnZSIsInF1YW50aXR5IiwicmV0YWlsIiwidG90YWwiLCJzdWJUb3RhbCIsInNlbGVjdEl0ZW0iXSwibWFwcGluZ3MiOiJBQUFBLE9BQVNBLGNBQVQsS0FBK0IsWUFBL0I7O0FBRUEsY0FBZUEsZ0JBQWU7QUFDNUJDLFVBQVc7QUFDVEMsR0FBSSxvQkFESztBQUVUQyxlQUFnQixhQUZQLENBRGlCOztBQUs1QkMsU0FBVTtBQUNSRixHQUFJLG1CQURJO0FBRVJDLGVBQWdCLG9CQUZSLENBTGtCOztBQVM1QkUsT0FBUTtBQUNOSCxHQUFJLG9CQURFO0FBRU5DLGVBQWdCLFlBRlYsQ0FUb0I7O0FBYTVCRyxNQUFPO0FBQ0xKLEdBQUksZ0JBREM7QUFFTEMsZUFBZ0IsT0FGWCxDQWJxQjs7QUFpQjVCSSxTQUFVO0FBQ1JMLEdBQUksbUJBREk7QUFFUkMsZUFBZ0IsT0FGUixDQWpCa0I7O0FBcUI1QkssV0FBWTtBQUNWTixHQUFJLHFCQURNO0FBRVZDLGVBQWdCLGFBRk4sQ0FyQmdCLENBQWYsQ0FBZiIsImZpbGUiOiJTa3UubWVzc2FnZXMuanMiLCJzb3VyY2VSb290IjoiL2FwcCIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCB7IGRlZmluZU1lc3NhZ2VzIH0gZnJvbSAncmVhY3QtaW50bCc7XG5cbmV4cG9ydCBkZWZhdWx0IGRlZmluZU1lc3NhZ2VzKHtcbiAgaXRlbUxhYmVsOiB7XG4gICAgaWQ6ICdpMThuLnNrdS5pdGVtTGFiZWwnLFxuICAgIGRlZmF1bHRNZXNzYWdlOiAnU2VsZWN0IEl0ZW0nLFxuICB9LFxuICBxdWFudGl0eToge1xuICAgIGlkOiAnaTE4bi5za3UucXVhbnRpdHknLFxuICAgIGRlZmF1bHRNZXNzYWdlOiAnUmVxdWVzdGVkIFF1YW50aXR5JyxcbiAgfSxcbiAgcmV0YWlsOiB7XG4gICAgaWQ6ICdpMThuLnNrdS5za3VSZXRhaWwnLFxuICAgIGRlZmF1bHRNZXNzYWdlOiAnU2t1IFJldGFpbCcsXG4gIH0sXG4gIHRvdGFsOiB7XG4gICAgaWQ6ICdpMThuLnNrdS50b3RhbCcsXG4gICAgZGVmYXVsdE1lc3NhZ2U6ICdUb3RhbCcsXG4gIH0sXG4gIHN1YlRvdGFsOiB7XG4gICAgaWQ6ICdpMThuLnNrdS5zdWJUb3RhbCcsXG4gICAgZGVmYXVsdE1lc3NhZ2U6ICdUb3RhbCcsXG4gIH0sXG4gIHNlbGVjdEl0ZW06IHtcbiAgICBpZDogJ2kxOG4uc2t1LnNlbGVjdEl0ZW0nLFxuICAgIGRlZmF1bHRNZXNzYWdlOiAnU2VsZWN0IEl0ZW0nLFxuICB9LFxufSk7XG4iXX0=


//////////////////
// WEBPACK FOOTER
// ./src/components/StockLift/Sku/Sku.messages.js
// module id = 2302
// module chunks = 0